(function () {
  function setCookie(name, value, days) {
    var expires = '';
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie =
      name + '=' + encodeURIComponent(value) + expires + '; path=/';
  }

  function removeLoader() {
    var loader = document.getElementById('page-loader');
    document.documentElement.classList.remove('loading-active');
    document.documentElement.classList.remove('loading-skip');

    if (loader) {
      loader.remove();
    }
  }

  function playLoaderAnimation() {
    var loader = document.getElementById('page-loader');
    var logo = document.querySelector('.page-loader__logo');

    if (!(loader instanceof HTMLElement)) return;
    if (!(logo instanceof HTMLElement)) return;

    setTimeout(function () {
      logo.classList.add('is-visible');
    }, 100);

    setTimeout(function () {
      logo.classList.remove('is-visible');
      logo.classList.add('is-hidden');
    }, 1800);

    setTimeout(function () {
      document.documentElement.classList.add('page-loaded');

      loader.addEventListener(
        'transitionend',
        function (e) {
          if (e.target === loader && e.propertyName === 'opacity') {
            removeLoader();
          }
        },
        { once: true }
      );

      loader.classList.add('is-hidden');
    }, 2700);

    setTimeout(function () {
      removeLoader();
    }, 3900);

    setCookie('top_loader_shown', '1', 1);
  }

  function initLoader() {
    var loader = document.getElementById('page-loader');

    if (!(loader instanceof HTMLElement)) return;

    if (document.documentElement.classList.contains('loading-skip')) {
      removeLoader();
      return;
    }

    if (document.documentElement.classList.contains('loading-active')) {
      playLoaderAnimation();
      return;
    }

    removeLoader();
  }

  initLoader();
  window.addEventListener('pageshow', initLoader);
})();
